// extracted by mini-css-extract-plugin
module.exports = {"Slider":"videoPanel_Slider__S6ZXi","flexCenter":"videoPanel_flexCenter__23eol","Fluid":"videoPanel_Fluid__1KOd1","center":"videoPanel_center__10KPB"};